module.exports = __webpack_public_path__ + "img/johanna-labudda.bc6fdf86.jpg";